import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AndroidIcon,
  IphoneIcon,
  GameIcon,
  CustomSoftIcon,
  SoftwareProIcon,
  SoftwareMainIcon,
} from "../../../app-constants";
import { Link } from "gatsby";

const StackItem = [
  {
    icon: AndroidIcon,
    title: "Android app development",
    description: (
      <>
        We specialize in{" "}
        <Link to="/android-app-development">Android app development</Link> using
        the latest stack and efficient strategies. Our skilled team capitalize
        the full potential of the Android platform to create high-performance
        and engaging apps. We ensure that your Android app streamlines your
        business operations while maintaining a solid online presence.
      </>
    ),
  },
  {
    icon: IphoneIcon,
    title: "Iphone app development",
    description: (
      <>
        You can elevate your brand with TekRevol's{" "}
        <Link to="/iphone-app-development" rel="noopener" aria-label="TekRevol">
          iPhone app development services
        </Link>{" "}
        Our meticulously designed apps are tailored to make the most of iOS's
        capabilities. We focus on delivering a premium user experience while
        maximizing user engagement to help your business compete in the market
        effectively.
      </>
    ),
  },
  {
    icon: GameIcon,
    title: "Game app development",
    description: (
      <>
        We bring your gaming vision to life with our{" "}
        <Link to="/game-development" rel="noopener" aria-label="TekRevol">
          game app development services
        </Link>{" "}
        . Our expert developers push the boundaries of user experience by
        creating immersive and entertaining game apps. Our team combines
        creativity and technical expertise to deliver captivating gaming
        experiences that keep users coming back for more.
      </>
    ),
  },
  {
    icon: CustomSoftIcon,
    title: "Custom Software Development",
    description: (
      <>
        We have vast experience in{" "}
        <Link
          to="/custom-software-development"
          rel="noopener"
          aria-label="TekRevol"
        >
          custom software development
        </Link>{" "}
        services in Houston. Our expert team designs and builds tailored
        software solutions considering your requirements. We empower your
        business to thrive in the digital age by transforming your vision into a
        reality, ensuring that your software operates seamlessly
      </>
    ),
  },
  {
    icon: SoftwareProIcon,
    title: "Software Product Development",
    description:
      "Our expertise in software product development makes us a reliable choice for businesses around the world. From conceptualization to launch, we take your innovative ideas and turn them into market-ready software products. Our comprehensive approach ensures that your software makes a significant impact in the market.",
  },
  {
    icon: SoftwareMainIcon,
    title: "Software Support and Maintenance",
    description:
      "Our commitment goes beyond software development as we also provide ongoing software support and maintenance to ensure the optimal performance of your software. Our proactive approach ensures that your software remains optimized, secure, and up-to-date, enabling right focus on core business objectives.",
  },
];

function Improvise(props) {
  return (
    <div className="improvise_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={4}
            className="m-xl-auto m-xxl-0"
          >
            <h2>TekRevol’s App and Software Development Services in Houston</h2>
            <p className="impro_para">
              We are a renowned custom software development company in Houston,
              proficient in creating customer-centric, and quality-enriched
              digital solutions. Here’s a quick overview of our best software
              development services in Houston:
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
            <div className="stack_box">
              {StackItem.map((item, index) => (
                <div className="stack_item" key={index}>
                  <div className="stack_title">
                    {item.icon}
                    <h5>{item.title}</h5>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Improvise;
